import {
  DRIVE_TEXT_EXTRACTION_CADENCE_MINUTES,
  DRIVE_TEXT_EXTRACTION_MAX_FILES,
} from '@vivport/backend/types';

function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return hours > 0 ? `${hours}h ${rest}m` : `${rest}m`;
}

export function formatTextReadiness(input: { eligible: number; ready: number; backgroundExtraction: boolean }): string {
  if (!input.backgroundExtraction) {
    return 'Text is fetched when a document is opened';
  }
  const base = `Text ready: ${input.ready.toLocaleString()} of ${input.eligible.toLocaleString()} documents`;
  const remaining = Math.max(0, input.eligible - input.ready);
  if (remaining === 0) {
    return base;
  }
  const runs = Math.ceil(remaining / DRIVE_TEXT_EXTRACTION_MAX_FILES);
  const minutes = runs * DRIVE_TEXT_EXTRACTION_CADENCE_MINUTES;
  return `${base} (≈ ${runs} run${runs === 1 ? '' : 's'}, ≈ ${formatDuration(minutes)} at ${DRIVE_TEXT_EXTRACTION_CADENCE_MINUTES}-min cadence)`;
}
